import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAlert } from '../contexts/AlertContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const RegisterPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useAlert();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    grade: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // 비밀번호 확인
    if (formData.password !== formData.confirmPassword) {
      setError('비밀번호가 일치하지 않습니다.');
      setLoading(false);
      return;
    }

    // 비밀번호 최소 길이 체크
    if (formData.password.length < 6) {
      setError('비밀번호는 최소 6자 이상이어야 합니다.');
      setLoading(false);
      return;
    }

    try {
      const registerData = {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        grade: formData.grade
      };

      await axios.post(`${API_BASE_URL}/api/auth/register`, registerData);
      
      showSuccess('회원가입이 성공적으로 완료되었습니다! 로그인 페이지로 이동합니다.');
      navigate('/login');
      
    } catch (error) {
      console.error('Register error:', error);
      if (error.response?.data?.detail) {
        setError(error.response.data.detail);
      } else {
        setError('회원가입 중 오류가 발생했습니다.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="login-container">
        <div className="card login-card">
          <h2>📝 회원가입</h2>
          <p>새 계정을 만들어 보세요</p>
          
          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">이름</label>
              <input
                type="text"
                className="form-input"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                placeholder="이름을 입력하세요"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">이메일</label>
              <input
                type="email"
                className="form-input"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                placeholder="your@email.com"
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">비밀번호</label>
              <input
                type="password"
                className="form-input"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                placeholder="비밀번호 (최소 6자)"
                required
                minLength="6"
              />
            </div>

            <div className="form-group">
              <label className="form-label">비밀번호 확인</label>
              <input
                type="password"
                className="form-input"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
                placeholder="비밀번호를 다시 입력하세요"
                required
                minLength="6"
              />
            </div>

            <div className="form-group">
              <label className="form-label">학습 단계 (선택사항)</label>
              <select
                className="form-input"
                value={formData.grade}
                onChange={(e) => setFormData({...formData, grade: e.target.value})}
              >
                <option value="">선택</option>
                <option value="elementary">Elementary (초등)</option>
                <option value="youth">Youth (중고등)</option>
                <option value="select100">Select 100 (수능 필독서)</option>
                <option value="general">General (일반)</option>
              </select>
            </div>
            
            <div className="form-group">
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
                style={{width: '100%'}}
              >
                {loading ? '가입 중...' : '회원가입'}
              </button>
            </div>
          </form>

          <div className="login-links">
            <p>이미 계정이 있으신가요?</p>
            <button 
              className="btn btn-secondary"
              onClick={() => navigate('/login')}
              style={{marginTop: '10px', width: '100%'}}
            >
              로그인하기
            </button>
            
            <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '5px'}}>
              <p style={{margin: '0', fontSize: '14px', color: '#1976d2'}}>
                💡 <strong>먼저 체험해보고 싶으신가요?</strong><br/>
                <button 
                  className="btn btn-link"
                  onClick={() => navigate('/test')}
                  style={{padding: '5px 0', fontSize: '14px', color: '#1976d2'}}
                >
                  게스트 모드로 게임 체험하기
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage; 